import { render, staticRenderFns } from "./GenericProps.vue?vue&type=template&id=1b108eea"
import script from "./GenericProps.vue?vue&type=script&lang=js"
export * from "./GenericProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports